/** Пустые состояния, ошибки и офлайн-баннер — единый вид на всё приложение. */

import type { ReactNode } from 'react';

export function EmptyState({
  icon,
  title,
  text,
  action,
}: {
  icon: string;
  title: string;
  text: string;
  action?: ReactNode;
}): JSX.Element {
  return (
    <div className="state">
      <div className="state__icon" aria-hidden="true">
        {icon}
      </div>
      <h3 className="state__title">{title}</h3>
      <p className="state__text">{text}</p>
      {action ? <div className="state__action">{action}</div> : null}
    </div>
  );
}

export function ErrorState({
  title,
  text,
  onRetry,
  retrying = false,
}: {
  title: string;
  text: string;
  onRetry(): void;
  retrying?: boolean;
}): JSX.Element {
  return (
    <div className="state state--error" role="alert">
      <div className="state__icon" aria-hidden="true">
        ⚠️
      </div>
      <h3 className="state__title">{title}</h3>
      <p className="state__text">{text}</p>
      <div className="state__action">
        <button
          type="button"
          className="btn btn--primary"
          onClick={onRetry}
          disabled={retrying}
        >
          {retrying ? 'Повторяем…' : 'Повторить'}
        </button>
      </div>
    </div>
  );
}

export function OfflineBanner(): JSX.Element {
  return (
    <div className="offline" role="status">
      <span className="offline__dot" aria-hidden="true" />
      Нет сети — показываем последние данные
    </div>
  );
}
